<template>
  <div class="live">
    <div class="msg">此为预览文章，预览{{ this.times }}次或截止到{{ this.fininshTime }}后失效</div>
    <LiveVideo :LiveDetail="docDetail.liveInfo" @onCountDownFinish="onCountDownFinish" />
    <div class="live-content">
      <div class="live-content-header">
        <div class="live-content-header-left">
          <div class="live-content-group" :class="activeTab == 1 ? 'active' : ''" @click="handleTab(1)">简介</div>
          <div v-if="docDetail.chatGroup" class="live-content-group" :class="activeTab == 0 ? 'active' : ''" @click="handleTab(0)">聊天</div>
          <!-- <div class="live-content-group" :class="activeTab == 2 ? 'active' : ''" v-if="isContent" @click="handleTab(2)">目录</div> -->
        </div>
        <div class="live-content-signup" v-if="docDetail.liveInfo && docDetail.liveInfo.videoStatus == 1" :class="signupId ? 'signuped' : ''" @click="handleSignUp">
          {{ signupId ? '已预约' : '预约观看' }}
        </div>
      </div>
    </div>

    <div v-if="activeTab == 0 && docDetail.chatGroup" class="tab-content intro">
      <div class="intro-content">
        <Tencentim :details_obj="docDetail.chatGroup" :isCollected="docDetail.documentDetail.isCollected" :simInfo="userInfo" :docInfo="docDetail.documentDetail"></Tencentim>
      </div>
    </div>

    <div v-if="activeTab == 1" class="contents">
      <div class="detail-doctors" v-if="doctorList.length > 0">
        <div v-for="o in doctorList" :key="o">
          <div class="doctors">
            <img class="doctors-img" :src="o.picUrl" />
            <div class="doctors-main">
              <div class="doctors-main-name">{{ o.name }}</div>
              <div class="doctors-main-bot">
                {{ o.title }}
                <div class="doctors-main-bot-line" />
                {{ o.company }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="contents-header">
        <div class="contents-header-line"></div>
        <div>{{ docTitle }}</div>
      </div> -->

      <div id="article" v-if="articleCon && articleCon.length">
        <div class="content">
          <div v-html="articleCon"></div>
        </div>
      </div>
      <!-- <div class="content-header mT-10">
          <div class="content-header-line"></div>
          <div>推荐中心</div>
        </div> -->
    </div>

    <!-- <div v-if="activeTab == 2">
      <van-list class="box" v-model="loading" :finished="finished" @load="onLoad" error-text="网络请求失败，点击重新加载" :immediate-check="false" loading-text="正在努力加载中">
        <div slot="finished" style="background-color: #f4f4fa; line-height: 1.5; font-size: 12px; color: #b3b3c1; padding: 10px 0 40px">已显示全部内容</div>
        <div v-for="(item, idx) in docList" :key="item.docId">
          <div class="bg-white">
            <div class="group" :class="idx == docList.length - 1 ? 'end' : ''" @click="handleSelect(item)">
              <div class="group-info">
                <div class="group-info-title">{{ item.title }}</div>

                <div class="group-info-name" v-if="item.masters.length > 0">{{ item.masters[0].name }} | {{ item.masters[0].hospital }}</div>

                <div class="group-info-check">
                  <span class="group-info-text">{{ item.readAmount }} 次查看</span>
                </div>
              </div>
              <div class="group-right">
                <img class="group-img" :src="item.smallPicurl || placeDoc" />
                <img class="group-play" v-if="item.showType == 'VIDEO'" :src="playUrl" />
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div> -->
  </div>
</template>
<script>
import Tencentim from '@/components/Tencentim'
import LiveVideo from '@/components/LiveVideo'
import { Toast } from 'vant'
// import TXIM from '@/assets/js/IM.js'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'Live',
  comments: {
    Toast
  },
  components: {
    LiveVideo,
    Tencentim
  },
  data() {
    return {
      docDetail: {},
      docId: this.$route.query.id,
      docTitle: '',
      isContent: false,
      signupId: false,
      pageNum: 0,
      docList: [],
      activeTab: 1,
      playUrl: this.$store.state.imgHeadUrl + 'play.png',
      placeDoc: this.$store.state.imgHeadUrl + 'place_doc.jpg',
      loading: true,
      finished: false,

      isRegistered: false,
      userId: '',

      txim: null,
      searchMsgTime: null,
      groupId: '',
      userInfo: {},
      sendText: '',
      msgList: [],
      sendLock: false,
      isWatchHistoryMsg: false,
      historyLock: false,
      historyView: false,
      articleCon: '',
      showArtcle: true,
      times: '',
      fininshTime: '',
      doctorList: []
    }
  },
  computed: mapState(['TXIMisready']),
  watch: {
    TXIMisready: function (newVal, oldVal) {
      if (newVal != oldVal && newVal) {
        setTimeout(() => {
          this.txim.tim.on(this.txim.EVENT.MESSAGE_RECEIVED, this.messageReceived, this)
        }, 500)
      }
    }
  },
  methods: {
    async getUserInfo() {
      const res = await this.$https.userInfo({ userId: 0 })

      if (typeof res === 'boolean' && !res) return
      console.log(res)
      this.userInfo = res
    },
    onCountDownFinish() {
      this.getDetail()
    },
    onLoad() {
      if (this.finished) return
      this.getDocumentCatalog()
    },
    async isScan() {
      console.log(this.docId)
      const res = await this.$https.scan({ id: this.docId })
      if (typeof res === 'boolean' && !res) return
      this.getdocumentdetail()
      this.getTime()
    },
    async getTime() {
      const resTime = await this.$https.remainTime({ id: this.docId })
      if (typeof resTime === 'boolean' && !resTime) return
      // console.log(res);
      this.times = resTime.times
      let fininshTimestamps = resTime.seconds
      let year = new Date(fininshTimestamps * 1000).getFullYear()
      let month = new Date(fininshTimestamps * 1000).getMonth() + 1
      let date = new Date(fininshTimestamps * 1000).getDate()
      let hour = new Date(fininshTimestamps * 1000).getHours()
      let min = new Date(fininshTimestamps * 1000).getMinutes()
      let second = new Date(fininshTimestamps * 1000).getSeconds()
      this.fininshTime = year + '-' + month + '-' + date + ' ' + hour + ':' + min + ':' + second
      // console.log();
    },
    async getdocumentdetail() {
      const res = await this.$https.preview({ id: this.docId })

      if (typeof res === 'boolean' && !res) return

      document.title = res.documentDetail.title
      this.docTitle = res.documentDetail.title
      this.doctorList = res.documentDetail.lecturers
      // if (res.eventId) {
      //   this.isContent = true
      // }
      // this.signupId = res.signUpId
      this.docDetail = res
      if (res.documentDetail.richTextUrl && res.documentDetail.richTextUrl) {
        this.articleCon = await axios.get(res.documentDetail.richTextUrl)
      } else {
        this.showArtcle = false
      }
    },
    handleTab(e) {
      this.docList = []
      switch (e) {
        case 0:
          this.activeTab = 0
          break

        case 1:
          this.activeTab = 1
          break

        case 2:
          this.activeTab = 2
          this.docList = []
          this.pageNum = 0
          this.finished = false
          this.loading = false
          this.getDocumentCatalog()
          break
      }
    },
    handleSelect(row) {
      if (row.showType == 'TEXT') {
        this.$router.push({
          path: '/DocumentDetail/' + row.docId
        })
      }
      if (row.showType == 'VIDEO') {
        this.docId = row.docId
        this.docTitle = ''
        this.docList = []
        this.docDetail = {}
        this.isContent = false
        this.signupId = false
        this.pageNum = 0
        this.activeTab = 1
        this.finished = false
        this.getdocumentdetail()
      }
    },
    async getDocumentCatalog() {
      ++this.pageNum
      this.$toast.loading({
        message: '请稍后...',
        forbidClick: true,
        duration: 0
      })
      const res = await this.$https.getDocumentCatalog({
        id: this.docId,
        index: this.pageNum,
        size: 8
      })
      if (typeof res === 'boolean' && !res) return
      this.$toast.clear()

      if (res.records.length <= 0) {
        this.finished = true
        return
      } else {
        this.loading = false
      }

      let row = res.records
      if (row.length > 0) {
        row.map((item) => {
          let pic = ''
          if (item.picUrl && item.picUrl.includes('>><<')) {
            pic = item.picUrl.split('>><<')
          }
          item.smallPicurl = pic.length > 1 ? pic[0] : item.picUrl
        })
      }
      if (this.docList.length >= res.total) {
        this.finished = true
      } else {
        this.loading = false
      }
      this.docList = [...this.docList, ...res.records]
    },
    // 点击报名
    async handleSignUp() {
      if (this.signupId) return

      if (!this.isRegistered) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '请登录注册后使用当前功能',
            confirmButtonText: '去登录',
            confirmButtonColor: '#2FA7FB'
          })
          .then((res) => {
            if (this.$rundev == 'Aliapp') {
              /* eslint-disable */
              my.navigateTo({ url: '/pages/login/index' })
            }
          })
        return
      }
      this.$toast.loading({
        message: '请稍后...',
        forbidClick: true,
        duration: 0
      })
      const res = await this.$https.signupOpenClass({
        actionType: 1,
        docId: Number(this.docId),
        subscribeType: 1
      })
      if (typeof res === 'boolean' && !res) return
      this.$toast.clear()
      this.$toast.success('报名成功')
      this.signupId = true
    },

    async getImSig() {
      let res = await this.$https.getImSig({
        id: this.roomId_,
        sourceType: this.sourceType,
        userType: this.userType,
        userId: this.userId
      })

      if (typeof res === 'boolean' && !res) {
        Toast('聊天系统连接失败')
        return
      }

      this.userInfo = {
        // userName: res.userName,
        // portraitUrl: res.portraitUrl,
        sig: res.sig,
        userId: res.userId
      }

      // this.txim = await new TXIM(this, res)
    },
    async getHistoryListOnly() {
      if (this.historyLock || this.isCompleted) return
      this.historyLock = true
      let res = await this.txim.onIMHistoryMessage(this.roomId_, this.searchMsgTime)

      if (!res.msgResults || res.msgResults.length == 0) {
        this.isCompleted = true
        return
      }

      let msgArr = []
      if (res.msgResults && res.msgResults.length > 0) {
        res.msgResults.map((row) => {
          row.cloudCustomData = JSON.parse(row.cloudCustomString)

          if (row.cloudCustomData.CustomType == 'LYH:Txt') {
            row.displayTimeHeader = formatTime(row.clientTime, 'MM:dd HH:mm')
            row.flow = row.senderUserID == this.userInfo.userId ? 'out' : 'in'
            row.payload = row.messageBaseElements[0]
            msgArr.unshift(row)
          }
        })
      }

      if (res.msgResults.length < 15) this.isCompleted = true

      if (this.msgList.length == 0 && msgArr.length > 0) this.scrollIntoView(msgArr[msgArr.length - 1])
      let historyText = ''
      if (this.msgList.length > 0 && msgArr.length > 0) {
        this.historyView = true
        historyText = this.msgList[0]
      }
      this.msgList = [...msgArr, ...this.msgList]
      if (historyText) this.scrollIntoView(historyText)
      this.historyLock = false

      if (res.msgResults.length > 0) this.searchMsgTime = res.msgResults[res.msgResults.length - 1].clientTime
    },
    messageReceived(event) {
      console.log('-----------IM聊天页received msg-----------', event)

      let msgArr = this.msgList || []
      let msg = ''

      event.data.map((row) => {
        if (row.payload.userDefinedField) row.payload.userDefinedField = JSON.parse(row.payload.userDefinedField)

        row.cloudCustomData = JSON.parse(row.cloudCustomData)

        if (row.to != this.groupId || row.cloudCustomData.CustomType != 'LYH:Txt') return

        row.displayTimeHeader = formatTime(row.time, 'MM-dd HH:mm')

        msgArr.push(row)
        msg = row
      })

      this.msgList = msgArr

      if (!this.isWatchHistoryMsg) this.scrollIntoView(msgArr[msgArr.length - 1])
    },
    async handleSendMsg() {
      if (this.sendLock || !this.sendText || !this.sendText.trim()) return
      this.sendLock = true

      const res = await this.$https.checkTextContent({ textContent: this.sendText, type: 'lyhchat' })

      if (typeof res === 'boolean' && !res) {
        Toast({
          duration: 3000,
          message: '包含敏感词无法发送'
        })
        this.sendLock = false
        return
      }

      this.txim.sendMessage(
        0,
        {
          roomType: 1,
          toUser: this.groupId,
          userName: this.userInfo.userName || '',
          headPortraitUrl: this.userInfo.portraitUrl || '',
          sendMsg: this.sendText,
          extData: null
        },
        (response) => {
          this.sendText = ''
          let event = response.data.message
          event.cloudCustomData = JSON.parse(event.cloudCustomData)
          event.displayTimeHeader = formatTime(event.time, 'MM-dd HH:mm')
          this.msgList.push(event)
          this.sendLock = false

          this.scrollIntoView(event)
        },
        (error) => {
          this.sendLock = false
        }
      )
    },
    handleScroll(e) {
      if (e.target.scrollTop == 0) {
        clearTimeout(historeTimes)
        historeTimes = setTimeout(() => {
          this.getHistoryListOnly()
        }, 500)
      }

      if (e.target.clientHeight + e.target.scrollTop < e.target.scrollHeight - 100) {
        this.isWatchHistoryMsg = true
      }
      if (e.target.clientHeight + e.target.scrollTop > e.target.scrollHeight - 101) {
        this.isWatchHistoryMsg = false
      }
    },
    scrollIntoView(e) {
      clearTimeout(scrollIntoViewTimess)
      scrollIntoViewTimess = setTimeout(() => {
        document.getElementById('imItem-' + e.clientTime).scrollIntoView({ behavior: this.historyView ? 'auto' : 'smooth' })

        this.historyView = false
      }, 300)
    },
  },
  created() {
    this.$store.commit('SET_TX_IM_READY', false)
    this.$toast.loading({
      message: '请稍后...',
      forbidClick: true,
      duration: 0
    })
    // this.docId = this.$route.query.id
    this.getUserInfo()
    this.isScan()
    // this.getdocumentdetail()
    // this.getImSig()
  }
}
</script>
<style scoped lang="less">
.live {
  max-width: 690px;
  min-height: 100vh;
  // background-color: #f4f4fa;
  margin: 0 auto;
}
.live-content {
  width: 100%;
  background: #ffffff;

  &-header {
    width: 100%;
    height: 44px;
    border-bottom: 1px solid #e5e5e8;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    &-left {
      display: flex;
      flex-direction: row;
    }
  }

  &-group {
    //width: 32px;
    height: 44px;
    box-sizing: border-box;
    border: 0;
    font-size: 16px;
    font-weight: bold;
    color: #9898a2;
    margin: 0 20px;
    line-height: 44px;

    &.active {
      color: #397CB5;
      border-bottom: 4px solid #397CB5;
      border-radius: 2px;
    }
  }

  &-signup {
    width: 68px;
    height: 28px;
    font-size: 12px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    background: #397CB5;
    border-radius: 18px;
    line-height: 28px;
    margin-right: 20px;

    &.signuped {
      color: #397CB5;
      background: #EBF2F8;
    }
  }
}

.box {
  width: 100%;
  height: calc(100vh - 56vw - 44px);
  background-color: #f4f4fa;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow-y: scroll;
}

.bg-white {
  background: #ffffff;
  box-sizing: border-box;
  padding: 0 20px;
}

.footer {
  width: 100%;
  height: 78px;
  font-size: 12px;
  color: #b3b3c1;
  box-sizing: border-box;
  padding-top: 20px;
  text-align: center;
}

.nodata {
  width: 100%;
  height: calc(100vh - 56vw - 44px);

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;

  img {
    display: block;
    width: 138px;
    height: 122px;
    margin-bottom: 16px;
  }

  div {
    font-size: 14px;
    color: #b3b3c1;
    text-align: center;
  }
}

.group {
  padding: 16px 0;
  border-bottom: 0.5px solid #e5e5e8;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;

  &.end {
    border-bottom: 0;
  }

  &-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &-title {
      width: 213px;
      height: 48px;
      font-size: 16px;
      color: #454556;
      line-height: 24px;
      overflow-wrap: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      word-break: break-all;
      -webkit-line-clamp: 2;
      /*! autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
    }

    &-name {
      width: 181px;
      height: 20px;
      font-size: 14px;
      color: #6f6f7a;
      line-height: 20px;
      overflow-wrap: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      word-break: break-all;
      -webkit-line-clamp: 1;
      /*! autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      margin: 4px 0;
    }

    &-img {
      display: block;
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }

    &-text {
      font-size: 12px;
      color: #9898a2;
    }
  }

  &-right {
    position: relative;
  }

  &-play {
    position: absolute;
    right: 10px;
    top: 52px;
    width: 22px;
    height: 22px;
  }

  &-img {
    display: block;
    width: 106px;
    height: 80px;
  }
}

.contents {
  width: 100%;
  height: e('calc(100vh - 100vw * (210 / 375) - 44px)');
  background: #ffffff;
  box-sizing: border-box;
  overflow-y: scroll;

  &-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 17px;
    font-weight: bold;
    color: #454556;
    padding: 16px 20px;

    &.mT-10 {
      border-top: 10px solid #f4f4fa;
    }

    &-line {
      width: 4px;
      height: 16px;
      background: #2fa7fb;
      margin-right: 8px;
    }
  }
}

::-webkit-scrollbar {
  display: none;
}

.tab-content.intro {
  height: calc((var(--vh, 1vh) * 100) - (210 / 375 * 100vw) - 44px);
      // padding: 17px 0px 16px;
      .intro-content {
        height: 100%;
        .title {
          padding: 8px 0 12px;
          display: flex;
          align-items: center;
          .text {
            //padding-left: 8px;
            font-size: 17px;
            color: #454556;
            font-weight: bold;
          }
        }
      }
    }
.msg {
  text-align: center;
  color: #cd0070;
  margin-top: 10px;
}
.detail-doctors {
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    margin-left: 20px;
    padding-right: 8px;
    box-sizing: border-box;
    overflow-x: scroll;

    .doctors {
      width: 320px;
      height: 60px;
      background: url('//static.yanzhiquan.net/docDoc-bg.png') no-repeat;
      background-size: cover;
      padding: 0 12px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 12px;

      &-img {
        width: 40px;
        height: 40px;
        margin-right: 8px;
      }

      &-main {
        flex: 1;
        display: flex;
        flex-direction: column;

        &-name {
          margin-bottom: 4px;
          font-size: 16px;
          color: #ffffff;
          font-weight: bold;
        }

        &-bot {
          width: 248px;
          font-size: 13px;
          color: #ffffff;
          overflow-wrap: break-word;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
          
          &-line {
            display: inline-block;
            width: 1px;
            height: 18px;
            background: #e9eeed;
            opacity: 0.2;
            margin: 0 9px;
            vertical-align: middle;
          }
        }
      }
    }
  }
</style>
